<mat-table [dataSource]="goals" class="mat-elevation-z8">
    <ng-container matColumnDef="playerA">
        <mat-cell *matCellDef="let element"> {{ element.playerA }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="roleA">
        <mat-cell *matCellDef="let element">
            @if (element.playerA) {
                <span class="text-muted">
                    {{ element.time }}
                    <i
                        class="fas fa-futbol"
                        [class.fa-futbol]="element.role === setScoreGoalRole.Offense"
                        [class.fa-shield-alt]="element.role === setScoreGoalRole.Defense"
                    ></i>
                </span>
            }
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="score">
        <mat-cell *matCellDef="let element"> {{ element.score }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="roleB">
        <mat-cell *matCellDef="let element">
            @if (element.playerB) {
                <span class="text-muted">
                    <i
                        class="fas fa-futbol"
                        [class.fa-futbol]="element.role === setScoreGoalRole.Offense"
                        [class.fa-shield-alt]="element.role === setScoreGoalRole.Defense"
                    ></i>
                    {{ element.time }}
                </span>
            }
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="playerB">
        <mat-cell *matCellDef="let element"> {{ element.playerB }} </mat-cell>
    </ng-container>

    <mat-row *matRowDef="let row; columns: ['playerA', 'roleA', 'score', 'roleB', 'playerB']"></mat-row>
</mat-table>
